import {Component, Input, input, OnInit} from '@angular/core';
import {InputTextModule} from "primeng/inputtext";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TooltipModule} from "primeng/tooltip";
import {AbstractProfileComponent} from "../abstract-profile.component";

@Component({
    selector: 'profile-textbox',
    imports: [
        InputTextModule,
        ReactiveFormsModule,
        TooltipModule,
        FormsModule
    ],
    templateUrl: './profile-textbox.component.html',
    styleUrl: './profile-textbox.component.scss',
    standalone: true
})
export class ProfileTextboxComponent extends AbstractProfileComponent implements OnInit {

    constructor() {
        super();
    }
}
